import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { Teacher, TeacherWithAvailability } from '@app/admin/model';
import { TeacherService } from '@app/admin/services';
import { User } from '@app/auth/model';
import {
  RecurrenceDay,
  RecurrenceDayLabel,
  TypeResponse,
} from '@app/shared/enum';
import { MessageService } from '@app/shared/services';
import { InitTeacherService } from '@app/teacher/services';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs';
import { first } from 'rxjs/operators';
import { default as swal } from 'sweetalert2';
@Component({
  selector: 'teacher-availability',
  templateUrl: './teacher-availability.component.html',
  styleUrls: ['./teacher-availability.component.css'],
})
export class TeacherAvailabilityComponent implements OnInit, AfterViewInit {
  public daysOfWeekDataList: Array<any>;
  public daysOfWeekDataList$ = new BehaviorSubject([]);
  public daysOfWeekList: Array<any> = [];
  public hoursOfDay: Array<any> = [];
  private teacherWithAvailability: TeacherWithAvailability;

  public validAvailability: boolean = true;
  public listErrorMessage: Array<any> = [];
  public errorMessage: string;
  public returnMessage: string;

  public submitted = false;
  public showData: boolean = false;

  public teacher: Teacher;
  public teacherId: number;
  public haveTeacherSelected = false;
  public teacherDataList: Array<any>;
  public flagSearchTeacher = false;
  public teacherList: any = [];
  public flagFiltering: boolean = false;

  public user: User = new User();

  constructor(
    private initTeacher: InitTeacherService,
    private modalService: NgbModal,
    private teacherService: TeacherService,
    private loading: MessageService,
    private cdr: ChangeDetectorRef
  ) {
    this.loading.showLoading();
    this.returnMessage = 'Nenhuma disponbilidade encontrada!';
    this.teacherDataList = new Array<any>();

    this.initTeacher.setConfigPage(false, false);
    this.teacher = this.initTeacher.teacher;
  }

  ngOnInit(): void {
    this.getDaysOfWeek();
    this.getHoursOfDay();
    this.getUserData();
    this.loading.showLoading();
  }

  ngAfterViewInit(): void {
    this.loading.showLoading();
  }

  private getUserData() {
    this.initTeacher
      .getTeacherUser()
      .pipe(first())
      .subscribe(
        (response: any) => {
          this.teacher = response;
          this.teacherId = this.teacher.id;
          this.user = this.initTeacher.user;
          if (this.teacherId > 0) {
            this.loadTeacherAvailability(this.teacherId);
            this.haveTeacherSelected = true;
          } else {
            this.showData = false;
            this.haveTeacherSelected = false;
            this.loading.hideLoading();
            return;
          }
        },
        (error: any) => {
          this.afterFailed();
          this.loading.hideLoading();
        }
      );
  }

  loadTeacherAvailability(teacherId: any) {
    this.teacherService.getAvailability(teacherId).subscribe(
      (response: any) => {
        if (response.typeResponse == TypeResponse.Success) {
          this.teacherWithAvailability = response.data;
          this.showData = true;
          this.daysOfWeekDataList$.next(this.daysOfWeekDataList);
          this.loading.hideLoading();
        } else {
          this.teacherWithAvailability = null;
          this.showData = false;
        }
      },
      (error: any) => {
        this.loading.hideLoading();
        this.showData = false;
      }
    );
  }

  getTemplateTeacher(data: Array<any>): any[] {
    if (data != null && data.length > 0) {
      let arrayTeachers: Array<any> = new Array<any>();
      this.teacherList = data.sort(function (a: any, b: any) {
        var textA = a.name.toLowerCase();
        var textB = b.name.toLowerCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
      for (let i = 0; i < data.length; i++) {
        const element: any = {
          id: data[i].id,
          name:
            this.pad(data[i].id, 6) +
            ' | ' +
            data[i].name +
            ' | ' +
            data[i].email,
        };
        arrayTeachers.push(element);
      }
      return arrayTeachers;
    }
    return new Array<any>();
  }

  pad(num: any, size: any) {
    if (num > 0) {
      num = num.toString();
      while (num.length < size) num = '0' + num;
      return num;
    }
    return num;
  }

  getCalendarByTeacher() {
    this.loading.showLoading();
    this.haveTeacherSelected = true;
    this.loadTeacherAvailability(this.teacherId);
  }

  setTeacher(value: any) {
    if (value) {
      this.teacherId = value;
      this.teacher = this.teacherList.find((x: any) => x.id == value);
    }
  }

  selectEvent(item: any) {
    // do something with selected item
    this.setTeacher(item.id);
  }

  onChangeSearch(val: string) {
    //console.log(val);
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }

  onFocused(e: any) {
    //console.log(e);
    // do something when input is focused
  }

  setTeacherAvailability(dayOfWeek: number, hour: any) {
    if (hour && dayOfWeek >= 0) {
      const currentStatus = this.checkAvailability(dayOfWeek, hour);

      if (currentStatus === 'busy') {
        swal({
          type: 'warning',
          title: `Não é possível definir este horário como disponível.`,
          text: `O horário das ${hour} na ${this.getDayName(
            dayOfWeek
          )} já está ocupado por outra aula.`,
          showConfirmButton: true,
        });
        return;
      }

      let item = this.teacherWithAvailability.teacherAvailabilityItems.find(
        (x) => x.dayOfWeek == dayOfWeek
      );

      if (item) {
        const index = item.hours.indexOf(hour, 0);
        if (index > -1) {
          item.hours.splice(index, 1);
        } else {
          item.hours.push(hour);
        }
        // IMPORTANTE: Crie uma nova referência para o array 'hours'
        // Isso força o Angular a detectar a mudança
        item.hours = [...item.hours];
        this.loading.hideLoading();
      } else {
        let newItem = {
          dayOfWeek: dayOfWeek,
          hours: [hour], // Adiciona a primeira hora para este dia
        };
        this.teacherWithAvailability.teacherAvailabilityItems.push(newItem);
        // IMPORTANTE: Crie uma nova referência para o array 'teacherAvailabilityItems'
        // Isso força o Angular a detectar a mudança
        this.teacherWithAvailability.teacherAvailabilityItems = [
          ...this.teacherWithAvailability.teacherAvailabilityItems,
        ];
        this.loading.hideLoading();
      }
    }

    // A chamada para this.daysOfWeekDataList$.next(this.daysOfWeekDataList);
    // pode não ser necessária, a menos que outras partes da UI dependam dela diretamente.
    // Se o problema é apenas na tabela, as linhas acima já devem resolver.

    // Force a detecção de mudanças.
    // Com as novas referências de array, o Angular já deve detectar.
    // Mas se você usa ChangeDetectionStrategy.OnPush, esta linha é essencial.
    this.cdr.detectChanges();
  }

  private getDayName(dayOfWeek: number): string {
    const days = [
      'Domingo',
      'Segunda-feira',
      'Terça-feira',
      'Quarta-feira',
      'Quinta-feira',
      'Sexta-feira',
      'Sábado',
    ];
    return days[dayOfWeek];
  }

  // No seu componente TypeScript
  checkAvailability(dayId: number, hour: string): 'busy' | 'free' | 'none' {
    // Encontra o item de disponibilidade para o dia da semana específico
    const dayAvailabilityItem =
      this.teacherWithAvailability?.teacherAvailabilityItems?.find(
        (item) => item.dayOfWeek === dayId
      );

    // Encontra o item com aula agendada para o dia da semana específico
    const dayBusyItem = this.teacherWithAvailability?.teacherBusyItems?.find(
      (item) => item.dayOfWeek === dayId
    );

    // Verifica se a hora específica está incluída na lista de horas para este dia
    if (dayBusyItem?.hours.includes(hour)) {
      // Se está incluída, significa que o horário está "ocupado" (ou selecionado/indisponível)
      return 'busy';
    } else if (dayAvailabilityItem?.hours.includes(hour)) {
      // Se o dia existe na lista, mas a hora não está nas 'hours' (ocupadas), então está "livre"
      return 'free';
    } else {
      // Se não há nenhum item de disponibilidade para este dia,
      // significa que todas as horas deste dia estão "livres"
      return 'none'; // Assumimos que se não há entrada, o professor está livre neste dia
    }
  }

  randomIntFromInterval(min: number, max: number): Array<number> {
    // min and max included
    let hours: Array<any> = [];
    let grade = Math.floor(Math.random() * (12 - min + 1) + min);
    for (let i = 0; i < grade; i++) {
      let hour = Math.floor(Math.random() * (max - min + 1) + min);
      let hours_str = hour < 10 ? '0' + hour : hour;
      hours.push(hours_str + ':00');
    }
    return hours;
  }

  getDaysOfWeek() {
    const daysOfWeekList: Array<object> = [];
    for (var value in RecurrenceDay) {
      if (Number.isInteger(Number.parseInt(value))) {
        daysOfWeekList.push({
          value: Number.parseInt(value),
          text: RecurrenceDayLabel.get(Number.parseInt(value)),
        });
      }
    }
    this.daysOfWeekDataList = this.getTemplateDaysOfWeekList(daysOfWeekList);
  }

  getTemplateDaysOfWeekList(data: Array<any>): any[] {
    if (data != null && data.length > 0) {
      this.daysOfWeekList = data;
      let arrayDayOfWeekList: Array<any> = new Array<any>();
      for (let i = 0; i < data.length; i++) {
        const element: any = {
          id: data[i].value,
          text: data[i].text,
        };
        arrayDayOfWeekList.push(element);
      }
      return arrayDayOfWeekList;
    }
    return new Array<any>();
  }

  getHoursOfDay() {
    // Loop from current hour number to 23
    for (var i = 0; i < 24; i++) {
      var hour = this.toHHMMSS(i * 60 * 60);
      var hour_split = hour.split(':');
      // Put loop counter into array with "00" next to it
      this.hoursOfDay.push(hour);
      this.hoursOfDay.push(hour_split[0] + ':30');
    }
  }

  toHHMMSS(number: any) {
    var sec_num = parseInt(number, 10); // don't forget the second param
    var hours = Math.floor(sec_num / 3600);
    //var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    //var seconds = sec_num - (hours * 3600) - (minutes * 60);
    let hours_str = hours < 10 ? '0' + hours : hours;
    //let minutes_str = hours < 10 ? "0"+minutes : minutes+"0";
    return hours_str + ':00'; ///+minutes_str;
  }

  done() {
    swal({
      title: 'Atualização de disponibilidade',
      html: 'Confirma a atualização de disponibilidade do(a) professor(a)?',
      type: 'warning',
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Sim, confirmar',
    }).then((confirmed) => {
      if (confirmed.value === true) {
        this.loading.showLoading();
        this.submitted = true;
        this.validAvailability = true;

        // Errors Cleaning
        this.errorMessage = '';

        // stop here if form is invalid
        if (!this.validAvailability) {
          this.loading.hideLoading();
          this.submitted = false;
          this.errorMessage = 'Disponibilidade informada é inválida.';
          return;
        }

        this.teacherWithAvailability =
          this.teacherWithAvailability.teacherAvailabilityItems !== null
            ? new TeacherWithAvailability({
                teacherId: this.teacherId,
                teacherAvailabilityItems:
                  this.teacherWithAvailability.teacherAvailabilityItems,
              })
            : new TeacherWithAvailability(null);

        this.teacherService
          .setAvailability(this.teacherId, this.teacherWithAvailability)
          .subscribe(
            (response: any) => {
              this.loading.hideLoading();
              if (response.typeResponse == TypeResponse.Success) {
                this.afterSuccess();
              } else {
                this.afterFailed();
              }
            },
            (error: any) => {
              this.loading.hideLoading();
              this.afterFailed();
            }
          );
      } else {
        this.cancel();
      }
    });
  }

  dismissModal() {
    this.modalService.dismissAll();
  }

  private getDismissReason(reason: any): string {
    if (reason === 3) {
      return 'by opening next modal';
    } else {
      //this.clear();

      //console.log(reason);

      if (reason === ModalDismissReasons.ESC) {
        return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
      } else if (reason === 2) {
        return 'by clicking on a close button';
      } else {
        return `with: ${reason}`;
      }
    }
  }

  cancel() {
    this.dismissModal();
  }

  cleanAvailability() {
    if (this.teacherWithAvailability.teacherAvailabilityItems) {
      this.teacherWithAvailability.teacherAvailabilityItems = [];
    }
    this.daysOfWeekDataList$.next(this.daysOfWeekDataList);
  }

  afterSuccess() {
    swal({
      type: 'success',
      title: `Disponibilidade atualizada com sucesso!`,
      showConfirmButton: true,
    }).then((result) => {
      this.loading.hideLoading();
      this.cancel();
    });
  }

  afterFailed() {
    swal({
      type: 'warning',
      title: `Não foi possível atualizar a disponibilidade!`,
      showConfirmButton: true,
    }).then((result) => {
      this.loading.hideLoading();
      this.cancel();
    });
  }
}
